import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import { TextField } from "app/components/FormikField/base";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Uuid } from "../../../../utils/uuid";
import {
  DividerStyled,
  FieldStyled,
  FontAwesomeIconStyled,
  FormLabelStyled,
  GridItemStyled,
  GridStyled,
  LinkAddStyled,
  LinkDeleteStyled
} from "./EditInsurerOwnerForm.styles";
const EditInsurerOwnerForm = ({ ownerInsurerId, intl }) => {
  const { values } = useFormikContext();
  return /* @__PURE__ */ React.createElement(Box, { sx: { width: "100%" } }, /* @__PURE__ */ React.createElement(GridStyled, { container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "insurers.agencyNumber" })), /* @__PURE__ */ React.createElement(
    FieldStyled,
    {
      color: "secondary",
      component: TextField,
      fullWidth: true,
      name: "agencyNumber",
      placeholder: intl.formatMessage({ id: "insurers.agencyNumber" }).toUpperCase(),
      required: true,
      variant: "outlined"
    }
  ))), /* @__PURE__ */ React.createElement(DividerStyled, null), /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "contacts",
      render: ({ push, remove }) => /* @__PURE__ */ React.createElement("div", null, values.contacts?.map((contact, contactIndex) => /* @__PURE__ */ React.createElement("div", { key: contact.contactId || contactIndex }, /* @__PURE__ */ React.createElement(GridStyled, { container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "insurers.contactName" })), /* @__PURE__ */ React.createElement(
        FieldStyled,
        {
          color: "secondary",
          component: TextField,
          fullWidth: true,
          name: `contacts[${contactIndex}].name`,
          placeholder: intl.formatMessage({ id: "insurers.contactName" }).toUpperCase(),
          variant: "outlined"
        }
      )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "insurers.phone" })), /* @__PURE__ */ React.createElement(
        FieldStyled,
        {
          color: "secondary",
          component: TextField,
          fullWidth: true,
          name: `contacts[${contactIndex}].phone`,
          placeholder: intl.formatMessage({ id: "insurers.phone" }).toUpperCase(),
          variant: "outlined"
        }
      )), /* @__PURE__ */ React.createElement(GridItemStyled, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "insurers.email" }), /* @__PURE__ */ React.createElement(
        LinkDeleteStyled,
        {
          href: "#",
          tabIndex: "-1",
          variant: "body1",
          onClick: (e) => {
            e.preventDefault();
            remove(contactIndex);
          }
        },
        /* @__PURE__ */ React.createElement(FontAwesomeIconStyled, { icon: faTrash }),
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "contacts.delete" })
      )), /* @__PURE__ */ React.createElement(
        FieldStyled,
        {
          color: "secondary",
          component: TextField,
          fullWidth: true,
          name: `contacts[${contactIndex}].email`,
          placeholder: intl.formatMessage({ id: "insurers.email" }).toUpperCase(),
          variant: "outlined"
        }
      ))), /* @__PURE__ */ React.createElement(DividerStyled, null))), (values.contacts?.length ?? 0) < 5 ? /* @__PURE__ */ React.createElement(
        LinkAddStyled,
        {
          href: "#",
          tabIndex: "-1",
          variant: "body1",
          onClick: (e) => {
            e.preventDefault();
            push({
              contactId: Uuid.newV4(),
              name: "",
              phone: "",
              email: "",
              ownerInsurerId
            });
          }
        },
        /* @__PURE__ */ React.createElement(FontAwesomeIconStyled, { icon: faPlus }),
        /* @__PURE__ */ React.createElement(FormattedMessage, { id: "contacts.add" })
      ) : /* @__PURE__ */ React.createElement(Typography, { variant: "body1", textAlign: "center" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "contacts.maximumReached", values: { b: (chunks) => /* @__PURE__ */ React.createElement("b", null, chunks), br: /* @__PURE__ */ React.createElement("br", null) } })))
    }
  ));
};
export default injectIntl(EditInsurerOwnerForm);
